














import {
  defineComponent,
  PropType,
} from '@nuxtjs/composition-api';
import { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';
import ProductDetails from 'components/catalog/Product/Details/ProductDetails.vue';

export default defineComponent({
  name: 'SimpleProduct',
  components: {
    ProductDetails,
    ProductOptions: () => import('components/catalog/Product/Details/ProductOptions/ProductOptions.vue')
  },
  transition: 'fade',
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    isFetching: {
      type: Boolean,
      default: true,
    }
  }
});
